import React, { FC, ReactNode } from 'react';

import styles from '#components/common/teaser-meta/TeaserDescription.module.scss';

type Props = {
  children: ReactNode;
  lines?: 1 | 2 | 3;
};

const TeaserDescription: FC<Props> = ({ lines = 3, children }) => {
  return React.createElement(
    'p',
    {
      className: `${styles.teaserDescription} tw-line-clamp-${lines}`,
    },
    children
  );
};

export default TeaserDescription;
